import { render, staticRenderFns } from "./BaseConfirmModal.vue?vue&type=template&id=6b216be8&"
import script from "./BaseConfirmModal.vue?vue&type=script&lang=js&"
export * from "./BaseConfirmModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b216be8')) {
      api.createRecord('6b216be8', component.options)
    } else {
      api.reload('6b216be8', component.options)
    }
    module.hot.accept("./BaseConfirmModal.vue?vue&type=template&id=6b216be8&", function () {
      api.rerender('6b216be8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/BaseConfirmModal.vue"
export default component.exports